import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VBtn,
    {
      staticClass: "elevation-0 mt-3",
      attrs: { color: "primary", "data-qa": "laboratories-list-select" },
      on: { click: _setup.chooseLaboratory },
    },
    [_vm._v("\n  Выбрать лабораторию\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }